import React from 'react';
import './uiPending.scss';

interface ProgressBarProps {
  /** 0–100; clamped. */
  value: number;
  tone?: 'primary' | 'success' | 'neutral';
  label?: string;
}

/** Horizontal meter. The fill width is the one data-driven inline style. */
const ProgressBar: React.FC<ProgressBarProps> = ({ value, tone = 'primary', label }) => {
  const pct = Math.min(100, Math.max(0, value));
  return (
    <div
      className={`ds-progress ds-progress--${tone}`}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(pct)}
      aria-label={label}
    >
      <div className="ds-progress__fill" style={{ width: `${pct}%` }} />
    </div>
  );
};

export default ProgressBar;
